import React from 'react';
import Card from '@material-ui/core/Card';
import TextField from '@material-ui/core/TextField';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import { DeereFetch } from '../../shared/fetch';



export class AlfaUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: '',
            firstName: '',
            lastName: '',
            role: '',
            associatedDealerNumber: '',
            country: '',
            comments: ''
        };

        this.handleChange = this.handleChange.bind(this);
    }

    async save() {

        this.setState({
            loading: true
        });
        try {
            await DeereFetch('/api/alfa/users', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(this.state)
            });
        } finally {
            this.setState({
                loading: false
            });
        }
    }

    handleChange(name) {
        return (e) => {
            this.setState({
                [name]: e.target.value
            });
        };
    }

    render() {

        return (
            <div>
                <Typography style={{ marginBottom: 10 }} variant="h5">Add a new FC User</Typography>

                <Card style={{ marginBottom: 20, margin : 'auto'}}>
                    <CardContent>
                        <div style={{marginRight : '30vw'}}>
                            <Grid container direction="row" item spacing={3}>
                                <Grid alignItems="flex-start" container direction="column" item justifyContent="space-around" sm={6} xs={12}>
                                    <Typography style={{ fontWeight: 'bold' }}>RACF ID</Typography>
                                    <TextField
                                        id="id"
                                        margin="none"
                                        onChange={this.handleChange('id')}
                                        placeholder="TMFE66E"
                                        size="small"
                                        value={this.state.id}
                                        variant="outlined"
                                    />
                                </Grid>
                                <Grid alignItems="flex-start" container direction="column" item justifyContent="space-around" sm={6} xs={12}>
                                    <Typography style={{ fontWeight: 'bold' }}>Associated Dealer</Typography>
                                    <TextField
                                        id="associated-dealer"
                                        margin="none"
                                        onChange={this.handleChange('associatedDealerNumber')}
                                        placeholder="TALF00025"
                                        size="small"
                                        value={this.state.associatedDealerNumber}
                                        variant="outlined"
                                    />
                                </Grid>
                                <Grid alignItems="flex-start" container direction="column" item justifyContent="space-around" sm={6} xs={12}>
                                    <Typography style={{ fontWeight: 'bold' }}>First Name</Typography>
                                    <TextField
                                        id="first-name"
                                        margin="none"
                                        onChange={this.handleChange('firstName')}
                                        placeholder="Jim"
                                        size="small"
                                        value={this.state.firstName}
                                        variant="outlined"
                                    />
                                </Grid>
                                <Grid alignItems="flex-start" container direction="column" item justifyContent="space-around" sm={6} xs={12}>
                                    <Typography style={{ fontWeight: 'bold' }}>Role</Typography>
                                    <TextField
                                        id="role-name"
                                        margin="none"
                                        onChange={this.handleChange('role')}
                                        placeholder="ASMGB"
                                        size="small"
                                        value={this.state.role}
                                        variant="outlined"
                                    />
                                </Grid>

                                <Grid alignItems="flex-start" container direction="column" item justifyContent="space-around" sm={6} xs={12}>
                                    <Typography style={{ fontWeight: 'bold' }}>Last Name</Typography>
                                    <TextField
                                        id="last-name"
                                        margin="none"
                                        onChange={this.handleChange('lastName')}
                                        placeholder="Gleason"
                                        size="small"
                                        value={this.state.lastName}
                                        variant="outlined"
                                    />
                                </Grid>


                                <Grid alignItems="flex-start" container direction="column" item justifyContent="space-around" sm={6} xs={12}>
                                    <Typography style={{ fontWeight: 'bold' }}>Country</Typography>
                                    <Select
                                        inputProps={{
                                            name: 'country',
                                            id: 'country'
                                        }}
                                        onChange={this.handleChange('country')}
                                        style={{ minWidth: 220, maxHeight: '2.5em' }}
                                        value="UK"
                                        variant="outlined">
                                        <MenuItem value="UK">United Kingdom</MenuItem>
                                        <MenuItem value="DE">Germany</MenuItem>
                                        <MenuItem value="ES">Spain</MenuItem>
                                    </Select>
                                </Grid>
                                <Grid alignItems="flex-start" container direction="column" item justifyContent="space-around" sm={12} xs={12}>
                                    <Typography style={{ fontWeight: 'bold' }}>Comments</Typography>
                                    <TextField
                                        id="comments"
                                        margin="none"
                                        onChange={this.handleChange('comments')}
                                        placeholder="Adding new user TM3663FE"
                                        size="small"
                                        value={this.state.comments}
                                        variant="outlined"
                                    />
                                </Grid>
                            </Grid>
                            <Grid alignItems="flex-start" container direction="row" item justifyContent="space-between" sm={3} style={{marginTop: 20}} xs={12}>
                                <Button
                                    variant="contained"
                                    // disabled={this.state.loading }
                                    // onClick={this.clear}
                                >
                                    Clear
                                </Button>
                                <div style={{ position: 'relative'}}>
                                    <Button
                                        color="primary"
                                        onClick={() => this.save()}
                                        //disabled={this.state.loading}
                                        variant="contained"
                                    >
                                        Save
                                    </Button>
                                </div>
                            </Grid>
                        </div>
                    </CardContent>
                </Card>

            </div>
        )
    }
}
